export const FORM_KEY_SYNC = 'sync'
export const FORM_KEY_ONLINE_STORE_WIDGET_ID = 'onlineStoreWidgetId'
export const FORM_KEY_INSTALL_ONLINE_STORE_WIDGET_ENABLED =
  'installOnlineStoreWidgetEnabled'
